"use strict";


export default function main() {

    $(document).ready(function() {

        //------------------------------------------------------
        //	フェード
        //------------------------------------------------------  
        $(".fade").each(function(i) {
            $(this).hover(function() {
                $(this).stop().fadeTo(200, 0.7);
            }, function() {
                $(this).stop().fadeTo(200, 1);
            });
        });

        //------------------------------------------------------
        //	スクロール
        //------------------------------------------------------  
        $('a[href^="#"]').click(function() {
            var speed = 400;
            var href = $(this).attr("href");
            var target = $(href == "#" || href == "" ? 'html' : href);
            var position = target.offset().top;
            $('body,html').animate({
                scrollTop: position
            }, speed, 'swing');
            return false;
        });

    });
}